export default "__VITE_ASSET__9f6568c6__"